/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pesticide_NewInputs */

const vi_pesticide_new = /** @type {(inputs: Pesticide_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm thuốc`)
};

/**

* @param {Pesticide_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pesticide_new = /** @type {((inputs?: Pesticide_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pesticide_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pesticide_new(inputs)
});